const ROLE_USER = 'user';
const ROLE_ADMIN = 'admin';
const ROLE_ROOT = 'root';

export {
  ROLE_USER,
  ROLE_ADMIN,
  ROLE_ROOT
}
